import { AppIcon, AppIcons, ICON_SIZES } from '@backrs_ui/common-ui';

import { Box, Typography, SxProps, Theme } from '@mui/material';

type SingleFilterButtonProps = Readonly<{
  name: string;
  iconName: AppIcons;
  isSelected: boolean;
  toggleFilter: () => void;
}>;

export const SingleFilterButton = ({
  name,
  iconName,
  isSelected,
  toggleFilter,
}: SingleFilterButtonProps) => (
  <Box onClick={toggleFilter} sx={singleFilterButtonStyle(isSelected)}>
    <Box sx={renderValueStyle}>
      <Box sx={renderValueIconStyle}>
        <AppIcon
          iconName={iconName}
          diameter="20px"
          color={isSelected ? 'Colors/Text/text-primary' : 'Colors/Text/text-placeholder'}
        />
      </Box>
      <Typography
        variant="text-md-medium"
        color={({ backrs }) =>
          isSelected
            ? backrs.colors['Colors/Text/text-primary']
            : backrs.colors['Colors/Text/text-placeholder']
        }
      >
        {name}
      </Typography>
    </Box>
  </Box>
);

const renderValueStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: backrs.spacing['spacing-sm'],
});

const renderValueIconStyle: SxProps<Theme> = {
  width: ICON_SIZES['20px'],
  height: ICON_SIZES['20px'],
};

const singleFilterButtonStyle =
  (isSelected: boolean): SxProps<Theme> =>
  ({ backrs }) => ({
    borderRadius: backrs.radius['radius-md'],
    border: `1px solid ${isSelected ? backrs.colors['Colors/Foreground/fg-primary'] : backrs.colors['Colors/Foreground/fg-quaternary']}`,
    paddingY: backrs.spacing['spacing-sm'],
    paddingX: backrs.spacing['spacing-lg'],
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: backrs.colors['Colors/Background/bg-primary'],
    boxShadow: backrs.shadows['shadow-xs'],
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
      boxShadow: backrs.shadows['shadow-lg'],
    },
  });
